"use client";

import { Header } from "@/figma/components/Header";
import { Hero } from "@/figma/components/Hero";
import { KeyFeatures } from "@/figma/components/KeyFeatures";
import { PillarsSections } from "@/figma/components/PillarsSections";
import { TrustSection } from "@/figma/components/TrustSection";
import { Footer } from "@/figma/components/Footer";
import type { HomePageContent } from "@/lib/page-content-types";

export function HomePage({ content }: { content?: HomePageContent | null }) {
  return (
    <div className="min-h-screen" style={{ fontFamily: "var(--font-body)" }}>
      <Header />
      <main>
        <Hero content={content?.hero} />
        <KeyFeatures features={content?.keyFeatures} />
        <PillarsSections pillars={content?.pillars} />
        <TrustSection content={content?.trust} />
      </main>
      <Footer />
    </div>
  );
}
